import React from "react";
import stylesBtn from "./Button.module.scss";

/**
 *
 * @param {svg} = image format svg
 * @param {text} = string button text
 * @param {styles} = type = string = different style in Button.module.scss
 * @param {tooltip} = string = texte du tooltip (court, en français)
 * @returns
 */
const Button = ({ svg, text, styles, type, onPress, id, disabled, tooltip }) => {
  const hasTooltip = tooltip ? "has-tooltip" : "";
  return (
    <>
      <button
        onClick={onPress}
        disabled={disabled}
        type={type}
        className={`${stylesBtn[styles]} ${disabled ? stylesBtn.disabled : ""} ${hasTooltip}`}
        id={id}
        aria-label={tooltip || undefined}
      >
        {text}
        {svg}
      </button>
    </>
  );
};

export default Button;
